import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const Masterclass = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [seconds, setSeconds] = useState(0);

  const handleProgress = (secs) => {
    setSeconds(secs);
  };

  const navigatepage = () => {
    navigate("/Apply");
  };

  return (
    <>
      <Header />
      <section>
        <div className="container">
          <div className="mt-2">
            <h6 className="watchtext">Watch This Video Fully</h6>
          </div>
          <h1 className="subsubtitle pt-3 theme_color pb-3">
            (Click the PLAY button to start the Video)
          </h1>
          <div className="row mt-3">
            <div className="col-lg-9 mx-auto ms-auto">
              <ReactPlayer
                // url="https://socialeagle.wistia.com/medias/vtpgz4xt11"
                url="https://socialeagle.wistia.com/medias/ksadb60crf"
                className="videoalignment"
                // controls={true}
                onProgress={(e) => handleProgress(e.playedSeconds)}
              />
            </div>
          </div>
          <h6 className="webinartext mt-5">
            Schedule a <span className="freecall">FREE Expert Call</span> to
            Become a <span className="freecall">Digital Entrepreneur.</span>
          </h6>
          <h6 className="clickbutton">
            Click the Button below &nbsp; <span className="clickbuttonend">
              (*Button will be enabled at the Middle of the video) and
            </span><br />
            <span className="book">Book a Call with Our Experts.</span>
          </h6>

          <div className="alignment py-4">
            <button
              className="applybutton"
              style={parseFloat(seconds) < 480 ? { display: "none" } : {}}
              onClick={() => {
                navigatepage();
                window.fbq("track", "Lead");
              }}
            >
              SCHEDULE A CALL HERE
            </button>
          </div>
        </div>
      </section >
    </>
  );
};

export default Masterclass;
